import { cn } from '@/lib/utils'

type MenuBulletListProps = {
  items: readonly string[]
  className?: string
}

export function MenuBulletList({ items, className }: MenuBulletListProps) {
  return (
    <ul
      className={cn(
        'space-y-2 font-sans text-[length:var(--menu-fs-sm)] leading-[1.55] text-body',
        className,
      )}
    >
      {items.map((item) => (
        <li key={item} className="flex gap-2.5">
          <span
            className="mt-[0.45em] h-1 w-1 shrink-0 rounded-full bg-primary/60"
            aria-hidden
          />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  )
}
